/* import __COLOCATED_TEMPLATE__ from './conversation-attachments.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import type AppService from 'embercom/services/app-service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import type AttachmentSettings from 'embercom/models/attachment-settings';
import { inject as service } from '@ember/service';

interface Args {
  attachmentSettings: AttachmentSettings;
  toggleUserAttachmentSettingsEnabled: () => void;
}

interface Signature {
  Args: Args;
}

export default class ConversationAttachments extends Component<Signature> {
  @tracked showRiskConfirmation = false;
  @service declare appService: AppService;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
  }

  get canUseVoiceNotes() {
    return (
      this.appService.app.canUseFeature('team-messenger-voice-notes') &&
      this.appService.app.hasConsentedToExternalAi
    );
  }

  @action
  toggleOtherFiles() {
    if (!this.args.attachmentSettings.allowedAttachmentFiletypesEnabled) {
      this.openOtherFilesModal();
    } else {
      this.args.attachmentSettings.set('allowedAttachmentFiletypesEnabled', false);
      this.args.attachmentSettings.set('allowedAttachmentFiletypesAgreedToRisk', false);
      this.args.attachmentSettings.set('allowedAttachmentFiletypesList', '');
    }
  }

  @action
  enableOtherFiles() {
    this.args.attachmentSettings.set('allowedAttachmentFiletypesEnabled', true);
    this.args.attachmentSettings.set('allowedAttachmentFiletypesAgreedToRisk', true);
    this.closeOtherFilesWarningModal();
  }

  @action
  openOtherFilesModal() {
    this.showRiskConfirmation = true;
  }

  @action
  cancelOtherFiles() {
    this.args.attachmentSettings.set('allowedAttachmentFiletypesEnabled', false);
    this.args.attachmentSettings.set('allowedAttachmentFiletypesAgreedToRisk', false);
    this.closeOtherFilesWarningModal();
  }

  @action
  closeOtherFilesWarningModal() {
    this.showRiskConfirmation = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Security::Tabs::ConversationAttachments': typeof ConversationAttachments;
    'new-settings/workspace/security/tabs/conversation-attachments': typeof ConversationAttachments;
  }
}
